var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDgi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 31,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dga-logo_svg__a)",
    d: "M11.355 15.018a.62.62 0 0 0-.255.495v5.02c0 .34.269.608.608.608.34 0 .608-.268.608-.608v-4.709l5.332-3.733c.184.099.382.141.608.141.721 0 1.315-.58 1.315-1.315 0-.721-.58-1.315-1.315-1.315-.721 0-1.315.58-1.315 1.315 0 .057 0 .113.014.156z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dga-logo_svg__b)",
    d: "M7.58 13.689v5.006a1.313 1.313 0 0 0 .608 2.475c.72 0 1.314-.58 1.314-1.315 0-.51-.282-.948-.707-1.16v-4.68l7.891-5.516a.62.62 0 0 0 .255-.495V4.271a.604.604 0 0 0-.608-.608.604.604 0 0 0-.608.608v3.408l-7.891 5.515a.52.52 0 0 0-.255.495"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dga-logo_svg__c)",
    d: "m17.026 15.358-2.008 1.414a.597.597 0 0 0-.142.848c.113.17.311.255.495.255.127 0 .24-.029.354-.113l2.008-1.415a.597.597 0 0 0 .141-.848.607.607 0 0 0-.848-.141"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dga-logo_svg__d)",
    d: "M20.872 18.907a.616.616 0 0 0-.863-.155l-9.517 6.66-9.517-6.66a.616.616 0 0 0-.863.155.616.616 0 0 0 .156.863l9.15 6.406-2.673 1.88a1.3 1.3 0 0 0-.608-.14c-.736 0-1.33.593-1.33 1.329 0 .735.594 1.329 1.33 1.329.735 0 1.329-.594 1.329-1.33 0-.056 0-.113-.014-.17l3.054-2.135 3.055 2.136c0 .056-.014.113-.014.17 0 .735.594 1.329 1.33 1.329.734 0 1.328-.594 1.328-1.33 0-.735-.593-1.329-1.329-1.329-.226 0-.424.057-.608.142l-2.673-1.881 9.15-6.406a.637.637 0 0 0 .127-.863"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dga-logo_svg__e)",
    d: "m3.959 4.469 2.008-1.414a.597.597 0 0 0 .141-.849.6.6 0 0 0-.495-.254.56.56 0 0 0-.353.113L3.252 3.479a.597.597 0 0 0-.142.848c.184.269.566.34.849.142"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dga-logo_svg__f)",
    d: "M12.19 2.475v3.351l-7.892 5.516a.62.62 0 0 0-.254.494v3.734c0 .34.268.608.608.608s.608-.269.608-.608v-3.408l7.89-5.516a.62.62 0 0 0 .255-.494V2.475A1.313 1.313 0 0 0 12.797 0c-.72 0-1.315.58-1.315 1.315.014.495.297.933.707 1.16"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dga-logo_svg__g)",
    d: "M2.714 10.196c.722 0 1.316-.58 1.316-1.315 0-.057 0-.113-.015-.156l5.6-3.917a.62.62 0 0 0 .255-.495V.623a.604.604 0 0 0-.608-.609.604.604 0 0 0-.608.608v3.38l-5.331 3.72a1.25 1.25 0 0 0-.609-.142c-.72 0-1.315.58-1.315 1.315a1.32 1.32 0 0 0 1.315 1.301"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dga-logo_svg__a",
    x1: 15.339,
    x2: 15.339,
    y1: 3.958,
    y2: 27.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ABAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0093B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#0080BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#774896"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dga-logo_svg__b",
    x1: 11.905,
    x2: 11.905,
    y1: 3.958,
    y2: 27.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ABAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0093B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#0080BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#774896"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dga-logo_svg__c",
    x1: 16.373,
    x2: 16.373,
    y1: 3.958,
    y2: 27.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ABAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0093B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#0080BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#774896"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dga-logo_svg__d",
    x1: 10.492,
    x2: 10.492,
    y1: 3.958,
    y2: 27.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29B2B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#1091B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#017EB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#704B98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dga-logo_svg__e",
    x1: 4.61,
    x2: 4.61,
    y1: 3.958,
    y2: 27.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ABAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0093B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#0080BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#774896"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dga-logo_svg__f",
    x1: 9.079,
    x2: 9.079,
    y1: 3.958,
    y2: 27.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ABAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0093B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#0080BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#774896"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dga-logo_svg__g",
    x1: 5.644,
    x2: 5.644,
    y1: 3.958,
    y2: 27.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ABAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0093B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#0080BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#774896"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDgi);
export default __webpack_public_path__ + "static/media/dgi.46cef89f1033e3e092105876432ae332.svg";
export { ForwardRef as ReactComponent };